
console.log("from custom cart 2");

$('body').on('click', '[name="checkout"]', function (e) {
    var frm = $(this).closest('form');
    console.log("asd")

    if ($("#custom_cities_ship").val().length == 0 || $("#custom_cities_ship").val() == "Seleccione...") {
        e.preventDefault();
        e.stopPropagation();
        // geckoShopify.CreatNotices("Debe seleccionar una ciudad");
        alert("Debe seleccionar una ciudad");
    }
    else if ($("#docnum").val().length == 0) {
        e.preventDefault();
        e.stopPropagation();
        // geckoShopify.CreatNotices("Debe ingresar el número de documento");
        alert("Debe ingresar el número de documento");
    }
    // else if (!frm.find('.js_agree_ck').is(':checked')) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     geckoShopify.CreatNotices(nt_settings.agree_checkout);
    // }
    else {
        var form = document.getElementById('form_cart');
        var postUrl =  form.action;
        var connector = postUrl.includes("?") ? "&" : "?";
        var parameters =[];

        parameters.push({name:"checkout[shipping_address][company]", value :$("#docnum").val()});  
        parameters.push({name:"checkout[shipping_address][country]", value :"CO"});  
        parameters.push({name:"checkout[shipping_address][province]", value : $( "#custom_provinces_ship option:selected" ).attr("name")});  
        parameters.push({name:"checkout[shipping_address][city]", value : $( "#custom_cities_ship option:selected" ).text()});  

        postUrl = urlFormatter(postUrl,parameters);
        form.action = postUrl;

        $(this).submit();
    }
});

var provinces_list = [];
var city_list = [];
var docs_list = [];for (var i = 0; i < provinces_list.length; i++) {
    var province = provinces_list[i];
    $("#custom_provinces_ship").append("<option value=" + province.code + " name="+province.shopifycode+">" + province.name + "</option");
}

$('#custom_provinces_ship').on('change', function () {
    var provinceId = $(this).val();

    var cities = city_list.filter(function (city) {
        return city.province == provinceId;
    });

    $("#custom_cities_ship").empty();
    $("#custom_cities_ship").append("<option >Seleccione...</option");
    for (var i = 0; i < cities.length; i++) {
        var city = cities[i];
        $("#custom_cities_ship").append("<option value=" + city.code + ">" + city.name + "</option");
    }
});

$("#custom_provinces_ship").val("05").trigger('change');$('.frm_cart_ajax_true').on('submit', function (event) {
    // var province = provinces_list.find(function (prov) {
    //   return prov.code == $("#custom_provinces_ship option:selected").val();
    // });

    // var city = $("#custom_cities_ship option:selected").text();
    // var doc = $("#docnum").val();

    // $(".frm_cart_ajax_true").attr('action', '/cart?checkout[shipping_address][company]=' + doc + '&checkout[shipping_address][city]=' + city + '&checkout[shipping_address][country]=Colombia&checkout[shipping_address][province]=' + province.shopifycode);
});

function urlFormatter(url , parameters){
    var parts = url.split("?");
    var url = parts[0];
    var newParameters =[];
    var map =[];

    if(parts[1] != null){
        var oldParameters =parts[1].split("&");

        for(var i in oldParameters){
            var parameter = oldParameters[i].split("=");

            map[parameter[0]] =parameter[1];
        }
    }

    for(var i in parameters){
        var parameter = parameters[i];

        map[parameter.name] =parameter.value;
    }
    for(var i in map){
        var value = map[i];

        newParameters.push(i + "=" + value);
    }

    url += "?"+ newParameters.join("&");

    return url;
}